import { createContext, useEffect, useState } from "react";
import { API_BASE } from "../utils/api";

export const UserContext = createContext(null);

export function UserProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem("user");
    if (!stored) return;

    const parsed = JSON.parse(stored);
    if (!parsed) {
      localStorage.removeItem("user");
      return;
    }
    setUser(parsed);

    // Si el asesor cambió de cliente manualmente, no sobreescribir con los parámetros del empleado
    if (parsed.idEmployee && !parsed._customerSwitched) {
      fetch(`${API_BASE}/api-ultra/api/ws/parameters_e_user?id_employee=${parsed.idEmployee}`)
        .then((r) => (r.ok ? r.json() : null))
        .then((params) => {
          if (params) {
            const refreshed = {
              ...params,
              token: parsed.token,
              // Preservar selecciones manuales del usuario
              bodegaId: parsed.bodegaId ?? params.bodegaId,
              bodegaName: parsed.bodegaName ?? params.bodegaName,
              idShipTo: "idShipTo" in parsed ? parsed.idShipTo : params.idShipTo,
              nameShipTo: "nameShipTo" in parsed ? parsed.nameShipTo : params.nameShipTo,
              addressShipTo: "addressShipTo" in parsed ? parsed.addressShipTo : params.addressShipTo,
              cityShipTo: "cityShipTo" in parsed ? parsed.cityShipTo : params.cityShipTo,
              phoneShipTo: "phoneShipTo" in parsed ? parsed.phoneShipTo : params.phoneShipTo,
              infoDelivery: "infoDelivery" in parsed ? parsed.infoDelivery : params.infoDelivery,
            };
            localStorage.setItem("user", JSON.stringify(refreshed));
            setUser(refreshed);
          }
        })
        .catch(() => {});
    }
  }, []);

  const login = (u) => {
    localStorage.setItem("user", JSON.stringify(u));
    localStorage.setItem("order_mode", "order");
    window.dispatchEvent(new Event("orderModeChange"));
    setUser(u);
  };

  const logout = () => {
    if (user?.changeCustomer) {
      localStorage.removeItem("order_express_items");
    }
    localStorage.removeItem("user");
    localStorage.removeItem("salesman");
    window.dispatchEvent(new CustomEvent("salesman-updated"));
    setUser(null);
  };

  const updateSelectedCustomer = (customer) => {
    if (!user) return;
    const updatedUser = {
      ...user,
      _customerSwitched: true,
      idCustomer: customer.idCustomer,
      customerId: customer.customerId,
      companyName: customer.companyName,
      nameShipTo: customer.shipToName,
      address: customer.address,
      city: customer.city,
      cedula: customer.cedula,
      idShipTo: customer.idShipTo || null,
      addressShipTo: customer.addressShipTo,
      cityShipTo: customer.cityShipTo,
      priceType: customer.priceType,
      creditTermId: customer.creditTermId,
      creditTerms: customer.creditTerms,
      infoDelivery: customer.infoDelivery,
      phone: customer.phone,
      phoneShipTo: customer.phoneShipTo,
      bodegaId: customer.bodegaId ?? user.bodegaId,
      bodegaName: customer.bodegaName ?? user.bodegaName,
    };

    login(updatedUser);
    window.location.href = "/dashboard";
  };

  return (
    <UserContext.Provider value={{ user, login, logout, updateSelectedCustomer }}>
      {children}
    </UserContext.Provider>
  );
}
